import { Box, Typography } from "@material-ui/core";
import { useTranslate } from "react-admin";
import { Control, FieldValues } from "react-hook-form";
import resourceNames from "../../../common/data/resourceNames";
import { HookFormAutocompleteInput } from "../../common/form/hook-form/inputs/HookFormAutocompleteInput";

interface Props<T extends FieldValues> {
  control: Control<T, object>;
}

export const GeometrisDeviceSelectorInput = <T extends FieldValues>(
  props: Props<T>
) => {
  const translate = useTranslate();
  return (
    <HookFormAutocompleteInput<T>
      {...props}
      name="serialNumber"
      label="ELD S/N"
      rules={{ required: translate("ra.validation.required") }}
      resource={resourceNames.MASTER_TENANT_ELDS}
      optionText="serialNumber"
      optionValue="serialNumber"
      sortField="serialNumber"
      renderOption={(option, _) => {
        return (
          <Box display="flex" flexDirection="row" gridGap={5}>
            <sup>{option.tenantName ?? "Unassigned"}</sup>
            <Typography variant="body1">{option.serialNumber}</Typography>
          </Box>
        );
      }}
    ></HookFormAutocompleteInput>
  );
};
